<template>
  <v-card flat tile class="mb-4">
    <v-toolbar flat>
      <v-toolbar-title>Water Consumption
        <v-progress-circular v-show="loader.water" :size="24" color="primary" indeterminate></v-progress-circular>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon to="/water/settings">
        <v-icon>more_horiz</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-xs-center">
            <div class="vocal-card-value headline">{{waterConsumedValue }}<span>oz</span></div>
            <div class="vocal-card-label">Water Consumed</div>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="text-xs-center">
            <v-btn round color="primary" dark v-on:click.native="addWater(8)">8oz</v-btn>
            <v-btn round color="primary" dark v-on:click.native="addWater(16)">16oz</v-btn>
            <v-btn round color="primary" dark v-on:click.native="addWater(24)">24oz</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  import CreateActivityMutation from '../mutations/CreateActivityMutation';
  import { ListActivitiesForCurrentUser, GetActivityByUserQuery } from '@/components/queries'

  export default {
    data() {
      return {
        loader: {
          water: false
        },
        waterConsumedValue: 0, 
      }
    },
    methods: {
      async refreshWater() {
        const result = await this.$apollo.query({
          variables: {
            actDate: localStorage.currentDate
          },
          query: ListActivitiesForCurrentUser
        })
        const items = result.data.listActivitiesForCurrentUser.items || [];
        const waterActivities = items.filter(it => it.activityType === 'WaterConsumption');
        const waterConsumedValue = waterActivities.reduce((t, a) => t + a.value, 0);

        this.waterConsumedValue = waterConsumedValue;
        localStorage.waterConsumedValue = waterConsumedValue;
        this.$root.$emit('waterChange', waterConsumedValue);
      },
      async addWater(ozValue) {
        this.loader.water = true;
        const data = await this.addWaterDB(ozValue);
        this.loader.water = false;
      },
      async addWaterDB(ozValue) {
        //gather inputs
        var waterInput = {
          id: localStorage.subID + '--' + (new Date().getTime()),
          username: localStorage.subID,
          actDate: localStorage.currentDate,
          activityType: 'WaterConsumption',
          timestamp: (new Date().getTime()),
          value: ozValue,
        }

        //add to dynamodb
        await this.$apollo.mutate({
          variables: {
            input: waterInput
          },
          mutation: CreateActivityMutation
        })

        await this.refresh();
      },
      async refresh() {
        await this.refreshWater();
      }
    },
    async mounted() {
      await this.refresh();

      this.$root.$on('DateChange', async data => {
        localStorage.currentDate = data;
        await this.refresh();
      });

    },
    updated() {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/WaterConsumptionHome.vue